/** Every screen name the widget can emit (the fixed part of `sidepanel:<tab>` included). */
export const WIDGET_SCREEN_NAMES = ['chat', 'cowork', 'sessions', 'capabilities', 'memory', 'notifications', 'sidepanel:', 'settings', 'outfits', 'pets', 'brief', 'starscribe'];
/** A tab id as a name part: the characters a name may carry, at most 40 of them. */
export function screenNamePart(value) {
    const part = value.replace(/[^A-Za-z0-9_.-]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40);
    return part || 'tab';
}
export function widgetScreenFor(state) {
    if (!state.open)
        return null;
    if (state.desktopWorkspace && state.settingsSection) {
        return state.settingsSection === 'look' ? { name: 'outfits' } : { name: 'settings', params: { tab: screenNamePart(state.settingsSection) } };
    }
    if (state.desktopWorkspace && state.showPets) {
        const route = state.petRoute;
        const brief = route ? route.view === 'brief-history' || route.view === 'brief-settings' || (route.view === 'pet' && route.tab === 'brief') : false;
        if (brief)
            return { name: 'brief' };
        return route ? { name: 'pets', params: { tab: screenNamePart(route.view === 'pet' && route.tab ? route.tab : route.view) } } : { name: 'pets' };
    }
    if (state.desktopWorkspace && state.showNotifications)
        return { name: 'notifications' };
    if (state.showMemory)
        return { name: 'memory' };
    if (state.showSessions)
        return { name: 'sessions' };
    if (state.showCapabilities)
        return { name: 'capabilities' };
    if (state.sidePanelTab)
        return state.sidePanelTab === 'starscribe' ? { name: 'starscribe' } : { name: `sidepanel:${screenNamePart(state.sidePanelTab)}` };
    return { name: state.composerWorkspace === 'cowork' ? 'cowork' : 'chat' };
}
/** A stable key for the effect that reports the screen: the name and its params. */
export function widgetScreenKey(screen) {
    return screen ? `${screen.name}|${JSON.stringify(screen.params ?? {})}` : '';
}
//# sourceMappingURL=widgetScreens.js.map